export default "__VITE_ASSET__BWhNgaUk__"